import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import WorkMedia from '../components/WorkMedia';
import HeroTicker from '../components/HeroTicker';
import siteData from '../data/site.json';
import workData from '../data/work.json';
import { SiInstagram, SiLinkedin, SiThreads, SiGithub } from 'react-icons/si';

const socialIcons = {
  Instagram: SiInstagram,
  LinkedIn: SiLinkedin,
  Threads: SiThreads,
  Github: SiGithub,
};

const Home = () => {
  const featured = workData.find((item) => item.featured) || workData[0];
  const latest = workData.slice(0, 6);

  return (
    <main className="main-wrapper">
      <div className="main-wrapper-left">
        <div className="home-hero-project">
          <div className="home-hero-project-inner">
            {featured ? (
              <div className="home-hero-project-preview">
                <div className="home-hero-project-preview-image-wrapper">
                  <Link to={`/work/${featured.slug}`} className="card-corner-bottom-right">
                    <div className="text-meta">Featured Project</div>
                    <div className="corner-bottom-right top w-embed">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                      </svg>
                    </div>
                    <div className="corner-bottom-right bottom w-embed">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                      </svg>
                    </div>
                  </Link>
                  <WorkMedia media={featured.media} className="home-hero-project-preview-image" />
                </div>
                <div className="hero-overlay-text">JO PORTUS</div>
                <HeroTicker />                
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="main-wrapper-right">
        <section className="section-home-about">
          <div className="home-about-left">
            <div className="home-about-profile">
              <img src="/images/headshots/JP2.1_BW.webp" loading="lazy" width="Auto" alt={siteData.name} className="border-radius-circle" />
              <div>
                <h1 className="heading-style-h5">{siteData.name}</h1>
                <div className="text-meta text-color-muted">{siteData.role}</div>
              </div>
            </div>
            <div className="max-width-medium">
              <div>{siteData.bio}</div>
            </div>
          </div>
          <div className="home-about-socials">
            {siteData.socials.map((social) => {
              const IconComponent = socialIcons[social.label];
              return (
                <a key={social.label} href={social.url} target="_blank" rel="noreferrer" className="social-card w-inline-block">
                  <div className="text-meta">{social.label}</div>
                  <div className="social-card-icon-wrapper">
                    <div className="social-card-icon w-embed">
                      {IconComponent ? <IconComponent /> : null}
                    </div>
                    <div className="social-card-icon-hover w-embed">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                        <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                      </svg>
                    </div>
                  </div>
                </a>
              );
            })}
            <Link to="/contact" className="social-card primary w-inline-block">
              <div className="text-meta text-color-inverse">Contact Me</div>
              <div className="social-card-icon-wrapper">
                <div className="social-card-icon w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z"></path>
                  </svg>
                </div>
                <div className="social-card-icon-hover w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                  </svg>
                </div>
              </div>
            </Link>
          </div>
        </section>

        <section className="section-home-projects">
          <div className="card-heading">
            <div className="card-heading-inner">
              <h2 className="text-meta">Selected Work</h2>
              <div className="icon-1x1-small w-embed">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                  <path d="M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"></path>
                </svg>
              </div>
            </div>
            <Link to="/work" className="button-text w-inline-block">
              <div className="button-text-inner">
                <div className="button-text-text">View All</div>
                <div className="button-text-line"></div>
              </div>
            </Link>
          </div>
          <div className="home-project-grid">
            {latest.map((item) => (
              <div key={item.slug} className="project-preview">
                <Link to={`/work/${item.slug}`} className="project-preview-image-wrapper w-inline-block">
                  <div className="project-preview-content">
                    <h3 className="text-meta">{item.title}</h3>
                    <div className="corner-top-left top w-embed">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                      </svg>
                    </div>
                    <div className="corner-top-left bottom w-embed">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                      </svg>
                    </div>
                  </div>
                  <img className='project-preview-image' src={item.media.poster} alt={item.media.alt || ''} loading="lazy" />
                </Link>
              </div>
            ))}
          </div>
          <Link to="/work" data-wf--button--variant="muted" className="button w-variant-783e12c6-01c7-f52a-602b-e5e2a46d1bfd w-inline-block">
            <div className="button-inner">
              <div className="button-inner-text">All Projects</div>
              <div className="button-inner-text-hover">All Projects</div>
            </div>
          </Link>
        </section>

        <section className="section-socials">
          {siteData.socials.map((social) => {
            const IconComponent = socialIcons[social.label];
            return (
              <a key={`social-${social.label}`} href={social.url} target="_blank" rel="noreferrer" className="social-card w-inline-block">
                <div className="text-meta">{social.label}</div>
                <div className="social-card-icon-wrapper">
                  <div className="social-card-icon w-embed">
                    {IconComponent ? <IconComponent /> : null}
                  </div>
                  <div className="social-card-icon-hover w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                      <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                    </svg>
                  </div>
                </div>
              </a>
            );
          })}
          <Link to="/contact" className="social-card primary w-inline-block">
            <div className="text-meta text-color-inverse">Contact Me</div>
            <div className="social-card-icon-wrapper">
              <div className="social-card-icon w-embed">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                  <path d="M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z"></path>
                </svg>
              </div>
              <div className="social-card-icon-hover w-embed">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                  <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                </svg>
              </div>
            </div>
          </Link>
        </section>

        <Footer />
      </div>
    </main>
  );
};

export default Home;

